<template>
  <div class="data86" :style="{
	  marginTop:list.top==0?0:'-120px'
  }">
	<div class="data86Box" >
		<div class="data86BoxOne">
			{{list.data.text1}}
		</div>
		<div class="data86BoxTwo">{{list.data.text2}}</div>
		<!-- <div class="data86BoxOne">沪械广审(文)第230917-53113号</div>
		<div class="data86BoxTwo">禁忌内容xxxxxxxxxx</div> -->
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
	props:{
		list:{
			typeof:Object,
			default:{}
		}
	},
    data() {
      return {
		
      }
    },
    mounted() {
		
    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.data86{
	width: 1200px;
	margin: 0 auto;
	padding: 30px 0;
	text-align: right;
	font-size: 12px;
	color: #8b8b8b;
	line-height:14pt;
	margin-top:-120px;
	.data86BoxOne{
		// margin-bottom: 14px;
	}
}
	@media screen and (max-width:1200px) {
		.data86{
			width: 100% !important;
			padding: 30px !important;
			margin-top:-30px !important;
			box-sizing: border-box;
		}
	}
</style>
